import { ReactNode } from "react";
import { FirebaseProvider } from "./FirebaseProvider";
import { NetworkProvider } from "./NetworkProvider";
import { AuthProvider } from "./AuthenticationProvider";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { SnackbarProvider } from "./SnackbarProvider";
import { TraderProvider } from "./TraderProvider";
import { AffiliateProvider } from "./AffiliateProvider";
import { PaymentsProvider } from "./PaymentsProvider";
import { TranslationProvider } from "./TranslationProvider";
import { Elements } from "@stripe/react-stripe-js";
import stripePromise from "../util/stripeSetup";

const darkTheme = createTheme({
	palette: {
		mode: "dark",
		primary: {
			main: "#131721",
		},
		secondary: {
			main: "#147A7A",
		},
		background: {
			default: "#131721",
		},
		text: {
			primary: "#FFF",
		},
	},
	typography: {
		fontFamily: "Work Sans",
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					backgroundColor: "#232839",
					fontFamily: "Work Sans",

					//borderRadius: 20,
				},
			},
		},
	},
});

export const Provider = ({ children }: { children: JSX.Element }) => {
	return (
		<ThemeProvider theme={darkTheme}>
			<CssBaseline />
			<TranslationProvider>
				<SnackbarProvider>
					<FirebaseProvider>
						<NetworkProvider>
							<AuthProvider>
								<Elements
									stripe={stripePromise}
									options={{
										appearance: { theme: "flat" },
									}}
								>
									<TraderProvider>
										<AffiliateProvider>
											<PaymentsProvider>
												{children}
											</PaymentsProvider>
										</AffiliateProvider>
									</TraderProvider>
								</Elements>
							</AuthProvider>
						</NetworkProvider>
					</FirebaseProvider>
				</SnackbarProvider>
			</TranslationProvider>
		</ThemeProvider>
	);
};
